import request from "@/router/axios";
import qs from 'qs';
export const login = (params) => {
    return request({
        url: `/api/login`,
        method: 'post',
        data: qs.stringify(params),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        meta: {
            isAuth: false
        }
    })
}
export const desktop = (startDate,endDate) => {
    return request({
        url: `/api/home/desktop`,
        method: 'get',
        params: {
            startDate,
            endDate
        }
    })
}
export const BigScreen = () => {
    return request({
        url: `/api/home/bigScreen`,
        method: 'get',
    })
}